import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Release() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();

    (async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_FACES_API_BASE}/release-seat`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('facesIDToken')}`,
            },
            signal: controller.signal,
          }
        );

        // Optional handling
        if (res.status === 401) {
          if (!cancelled) navigate('/login', { replace: true });
        }
      } catch (err) {
        // Optionally log or stash an error somewhere global
        console.error('release failed:', err);
      } finally {
        if (!cancelled) navigate('/menu', { replace: true });
      }
    })();

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [navigate]);

  return (
    <p style={{ color: 'white' }}>
      Releasing seat from your FACES™ session...
    </p>
  );
}
